import {
  productionIntercomSecretId,
  developIntercomSecretId
} from '@helpers/constants';

function hideIntercom() {
  const url = window.location.href;

  return url.includes('share')
    || url.includes('past_video')
    || /\/live-video-tour(\/|$)/.test(url); // LVT Stream and Past LVT pages
}

const intercomInitialize = (currentUser) => {
  if (!currentUser) return;

  const isLocalEnv = window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1');

  if (isLocalEnv) return;

  const isProduction = window.location.host === 'realync.com';

  const appID = isProduction ? productionIntercomSecretId : developIntercomSecretId;

  window.intercomSettings = { app_id: appID };

  if (currentUser) {
    window.intercomSettings.id = currentUser.id;
    window.intercomSettings.email = currentUser.email;
    window.intercomSettings.name = currentUser.name;
    window.intercomSettings.agent = 'YES';
    window.intercomSettings.is_client = 'YES';
    window.intercomSettings.hide_default_launcher = hideIntercom();
    window.intercomSettings.z_index = 998;
  }
  /* eslint-disable */
  (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',intercomSettings);}else{var d=document;var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};w.Intercom=i;function l(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + appID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);}if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})()
};

export default intercomInitialize;
